import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-160px text-nowrap" }, "Title & Description"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Permissions"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px text-end" }, "Actions")
  ])
], -1)
const _hoisted_4 = { class: "text-dark fw-bolder d-block fs-6" }
const _hoisted_5 = { class: "text-muted fw-bold text-muted d-block fs-7 mt-3" }
const _hoisted_6 = { class: "text-end" }
const _hoisted_7 = {
  class: "btn-group btn-group-sm pb-2 pt-1",
  role: "group"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (entry) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: entry.id
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(entry.title), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(entry.description), 1)
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.permission, (permissions) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "badge rounded-pill bg-primary text-wrap ms-1 mb-2",
                  key: permissions.id
                }, _toDisplayString(permissions.title), 1))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.emitEditEvent(entry)),
                  type: "button",
                  class: "btn btn-sm btn-warning",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#permissionsModal"
                }, " Edit ", 8, _hoisted_8),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.openDeleteModal(entry)),
                  "data-bs-target": "#deleteModal",
                  "data-bs-toggle": "modal",
                  class: "btn btn-sm btn-danger"
                }, " Delete ", 8, _hoisted_9)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}